import { render, staticRenderFns } from "./GlobalIntroWithParagraphs.vue?vue&type=template&id=779f1675&scoped=true&"
import script from "./GlobalIntroWithParagraphs.vue?vue&type=script&lang=js&"
export * from "./GlobalIntroWithParagraphs.vue?vue&type=script&lang=js&"
import style0 from "./GlobalIntroWithParagraphs.vue?vue&type=style&index=0&id=779f1675&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779f1675",
  null
  
)

export default component.exports